import { useBeforeDeadline } from '@/shared/hooks/use-before-deadline';

import { CONTACT_HISTORY_EDIT_WINDOW_MS } from './edit-window';

const editDeadline = (createdAt: string): string | null => {
  const createdAtMs = Date.parse(createdAt);
  return Number.isFinite(createdAtMs)
    ? new Date(createdAtMs + CONTACT_HISTORY_EDIT_WINDOW_MS).toISOString()
    : null;
};

export const useEntryEditWindow = (createdAt: string): boolean => {
  const deadline = editDeadline(createdAt);
  const withinWindow = useBeforeDeadline(deadline);
  return deadline !== null && withinWindow;
};
